/**
 * Waiting Period Helpers - AccessBank only
 */

const DEFAULT_WAITING_PERIOD_DAYS = 150;
const CLAIMABLE_DURING_WAITING_PERIOD = ['FUNERAL BENEFIT', 'ACCIDENTAL BENEFIT'];

export const isInWaitingPeriod = (benefit) => {
  if (!benefit || !benefit.created_at) {
    return false;
  }

  const createdAt = new Date(benefit.created_at);
  const waitingDays = benefit.waiting_period_in_days || DEFAULT_WAITING_PERIOD_DAYS;
  const waitingEndDate = new Date(createdAt.getTime() + waitingDays * 24 * 60 * 60 * 1000);

  return new Date() < waitingEndDate;
};

export const getWaitingPeriodEndDate = (benefit) => {
  if (!benefit || !benefit.created_at) {
    return null;
  }

  const createdAt = new Date(benefit.created_at);
  const waitingDays = benefit.waiting_period_in_days || DEFAULT_WAITING_PERIOD_DAYS;

  return new Date(createdAt.getTime() + waitingDays * 24 * 60 * 60 * 1000);
};

export const canClaimDuringWaitingPeriod = (benefitType) => {
  return CLAIMABLE_DURING_WAITING_PERIOD.includes(benefitType);
};

export const formatWaitingPeriodEndDate = (date) => {
  if (!date) return '';
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

export const buildBenefitsWithWarnings = (benefitTypes, memberBenefits) => {
  const warnings = [];

  const benefits = benefitTypes.map(function(benefitType) {
    const benefit = memberBenefits
      ? memberBenefits.find(function(b) { return b.type === benefitType; })
      : null;

    if (benefit && isInWaitingPeriod(benefit)) {
      warnings.push({
        benefitType: benefitType,
        canClaimDuringWaiting: canClaimDuringWaitingPeriod(benefitType),
        currentAmount: benefit.cover_amount_in_cents,
        waitingPeriodEndDate: getWaitingPeriodEndDate(benefit)
      });
    }

    return { type: benefitType };
  });

  return { benefits, warnings };
};
